import { DOCTYPES } from '@/constants/doctypes'
import { HAS_DETAIL_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeSystemSettingsHome, root: routeSystemSettingsRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.SYSTEM_SETTINGS]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
  },
  name: 'system-settings',
  path: 'system-settings',
  view: async () =>
    await import('@/components/viewsExternal/systemSettings/ViewSystemSettings.vue'),
})

export { routeSystemSettingsHome, routeSystemSettingsRoot }
